import { render, staticRenderFns } from "./attend.vue?vue&type=template&id=2a73d61a&"
import script from "./attend.vue?vue&type=script&lang=js&"
export * from "./attend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports